$(document).ready(function(){
    var $slider = $('.vendor-slider');

    // Initialize Slick slider
    $slider.slick({
      slidesToShow: 8,
      slidesToScroll: 1,
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });

    // Custom navigation buttons
    $('.slider-prev').on('click', function() {
      $slider.slick('slickPrev');
    });

    $('.slider-next').on('click', function() {
      $slider.slick('slickNext');
    });
  });